// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"az_nk","topHrTag":"az_ok","bottomHrTag":"az_pk","linksAndCookieBtn":"az_qk"};